<template>
<div>
  <div class="search-wrap">
    <el-button size="mini" @click="open()">创建模板</el-button>
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
    <el-button size="mini" @click="exportWords(1)">导出公示</el-button>
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="抄表月份">
        <el-date-picker
          v-model="mainObj.read_month"
          size="mini"
          type="month"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="pageChange(1)"
          placeholder="选择月">
        </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable clearable placeholder="仪表类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="公示名称">
        <el-input size="mini" placeholder="公示名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <el-table show-summary v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="id" label="id" width="80"></el-table-column>
      <el-table-column prop="name" label="公示名称 " width="200"></el-table-column>
      <el-table-column label="仪表类型" width="100">
        <template slot-scope="scope">
          {{listToidsByName(meter_type_list,scope.row.meter_types)}}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          {{listToidByName(status_list,scope.row.status)}}
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间 "  width="140"></el-table-column>

      <el-table-column prop="update_time" label="修改时间" width="140"></el-table-column>

      <el-table-column label="操作 " width="280">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="open(scope.row.id)">编辑</el-button>
          <el-button type="primary" size="mini" @click="exportWord(scope.row.id,2)">预览公示</el-button>
          <el-button type="primary" size="mini" @click="exportWord(scope.row.id,1)">导出公示</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
    <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>

  <MeterOrderPublicityEditor ref="MeterOrderPublicityEditorRef" />

<!--  <ApportionTemplateWin ref="ApportionTemplateWinRef" />-->
  <SelectMeterTree ref="SelectMeterTreeRef" />

  <ViewFile ref="ViewFile" />

</div>
</template>

<script>
import SelectMeterTree from "./components/SelectMeterTree";
import MeterOrderPublicityEditor from "./components/MeterOrderPublicityEditor";
import Http from "../../common/Http"
import ViewFile from "../../../Common/ViewFile";
import MeterOrderFlowHelp from "../../common/MeterOrderFlowHelp";
import MeterHttp from "../../common/MeterHttp";
export default {
  name: "MeterOrderPublicityList",
  inject:['mainObj','componentId','setComponentId'],
  components:{ViewFile, MeterOrderPublicityEditor, SelectMeterTree},
  data(){
    return{
      where:{
        name:"",
        meter_type:""
      },
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
      meter_type_list:[],
      status_list:[{id:0,name:'停用'},{id:1,name:'启用'}]
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.pageChange(1)
  },
  methods:{
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterOrderPublicity/getList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData.list= res.data.list;
          that.pageData.total= res.data.total;
          that.pageData.pageSize= res.data.pageSize;
          that.pageData.page= res.data.page;
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    open(id=null){
      const that=this;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目')
        return false;
      }
      that.$refs.MeterOrderPublicityEditorRef.show({
        project_id:that.mainObj.project_id,
        id:id
      },()=>{
        that.pageChange(1);
      })
    },
    setMeterApportion(template_id=0,meter_ids=[]){
      const that = this;
      let where = ERP.reJson(this.where);
      MeterHttp.post("MeterOrderPublicity/setMeterApportion",{
        project_id:that.mainObj.project_id,
        template_id:template_id,
        meter_ids:JSON.stringify(meter_ids),
        user_type:(that.$route.query.type||0),
      }, res => {
        if (res.code) {
          that.$message.success('设置成功')
        }else {
          that.$message.error(res.msg||'设置失败')
        }
      })
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      }, ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    listToidByName(list,id){
      let index=list.findIndex(ret=>ret.id==id)
      return (list[index]||{}).name||""
    },
    listToidsByName(list,ids){
      ids=ids.split(",").map(re=>re*1)
      return list.filter(ret=>ids.includes(ret.id)).map(re=>re.name).join(',');
    },
    exportWord(id,type=1){
      const that=this;
      if(!that.mainObj.read_month){
        that.$message.error("请选择抄表时间");
        return false;
      }
      MeterOrderFlowHelp.isMeterOrderFlowPass(that.mainObj.project_id,that.mainObj.read_month,flow_data=>{
          if(flow_data.code){
            ERP.showLoading()
            MeterHttp.post("MeterOrderPublicity/getMeterOrderPublicityWord",{
              project_id:that.mainObj.project_id,
              user_type:(that.$route.query.type||0),
              read_month: that.mainObj.read_month,
              publicity_id: id
            }, res => {
              ERP.hideLoading()
              if (res.code) {
                if(type===1){
                  window.open(res.data);
                }else {
                  that.$refs.ViewFile.show({
                    width: '90vw',
                    height:'80vh',
                    title:"文件预览",
                    src:res.data,
                    download(){
                      window.open(res.data)
                    }
                  })
                }
              }
            })
          }else {
            that.$message.error(flow_data.msg||"数据异常");
          }
      });
    },
    exportWords(type=1){
      const that=this;
      if(!that.mainObj.read_month){
        that.$message.error("请选择抄表时间");
        return false;
      }
      if(that.multipleSelection.length===0){
        that.$message.error("请选择公示模板");
        return false;
      }
      MeterOrderFlowHelp.isMeterOrderFlowPass(that.mainObj.project_id,that.mainObj.read_month,flow_data=>{
        if(flow_data.code){
          ERP.showLoading()
          MeterHttp.post("MeterOrderPublicity/getMeterOrderPublicityWords",{
            project_id:that.mainObj.project_id,
            user_type:(that.$route.query.type||0),
            read_month: that.mainObj.read_month,
            publicity_ids: that.multipleSelection.map(ret=>ret.id).join(',')
          }, res => {
            ERP.hideLoading()
            if (res.code) {
              if(type===1){
                window.open(res.data);
              }else {
                that.$refs.ViewFile.show({
                  width: '90vw',
                  height:'80vh',
                  title:"文件预览",
                  src:res.data,
                  download(){
                    window.open(res.data)
                  }
                })
              }
            }
          })
        }else {
          that.$message.error(flow_data.msg||"数据异常");
        }
      });
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    }
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderPublicityList.vue